import { getAxiosInstance } from "../ApiConfig";

const LoginToken = localStorage.getItem('cx_token');
const headers = {};
headers.Authorization = `Bearer ${LoginToken}`;

async function FetchAllApprovals() {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/findAllApprovalRuleByUserId`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function FetchAllSharedApprovals() {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/findAllSharedApproval`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function FetchAllApprovalMyList() {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/getAllRequestorApprovals`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function FetchAllApprovalSharedList() {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/getAllApproverApprovals`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function ruleDetailData(id) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/getByApprovalRuleId/${id}`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function checkConnection(id) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/checkConnectionForApprovalQueue/${id}`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function ruleSave(payload) {
    try {
        const response = await getAxiosInstance().post(`/usermgmt/createApprovalRule`, payload, { headers });
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function ruleUpdate(payload, id) {
    try {
        const response = await getAxiosInstance().put(`/usermgmt/updateApprovalRule/${id}`, payload, { headers });
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function updateRulesforMine(payload, action, automationId) {
    try {
        const response = await getAxiosInstance().put(`/usermgmt/removeUserFromAutomationRule/${automationId}/${action}`, payload, { headers });
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function updateRulesStatus(payload, action, automationId) {
    try {
        const response = await getAxiosInstance().put(`/usermgmt/updateBusinessRuleForAutomationStatus/${automationId}/${action}`, payload, { headers });
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function deleteRuleId(id) {
    try {
        const data = await getAxiosInstance().delete(`/usermgmt/deleteApprovalRule/${id}`, { headers });
        return data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function SaveApprovalQueue(status, id, payload) {
    try {
        const response = await getAxiosInstance().post(`/usermgmt/approvalProcessFunctionality/${status}/${id}`, payload, { headers });
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function QueueDetails(id) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/getApprovalProcessMstDetaiPage/${id}`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function deleteRequestId(id) {
    try {
        const data = await getAxiosInstance().delete(`/usermgmt/deleteApprovalApprovalProcessRequest/${id}`, { headers });
        return data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function addCommentsForApprovalProcess(payload, id) {
    try {
        const response = await getAxiosInstance().put(`/usermgmt/addCommentsForApprovalProcess/${id}`, payload, { headers });
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
export {
    FetchAllApprovals,
    ruleDetailData,
    ruleSave,
    ruleUpdate,
    addCommentsForApprovalProcess,
    deleteRuleId,
    FetchAllApprovalMyList,
    FetchAllApprovalSharedList,
    SaveApprovalQueue,
    FetchAllSharedApprovals,
    QueueDetails,
    deleteRequestId,
    updateRulesforMine,
    updateRulesStatus,
    checkConnection,
}